import { Alert, Flex, Typography } from "antd"
import React from "react"

interface LeadWizardMatchPanelProps {
  title: string
  description: string
  children: React.ReactNode
  more?: React.ReactNode
  footer?: React.ReactNode
}

/**
 * The single shell the unified duplicate-resolution card wears.
 *
 * `footer` is optional deliberately: a row with a lead already offers its own
 * way out and must not grow a second one at the bottom.
 */
export function LeadWizardMatchPanel({
  title,
  description,
  children,
  more,
  footer
}: LeadWizardMatchPanelProps) {
  return (
    <Alert
      type={"warning"}
      showIcon
      className={"mb-4"}
      message={title}
      description={
        <Flex vertical gap={"small"}>
          <Typography.Text type={"secondary"}>{description}</Typography.Text>

          <Flex
            vertical
            gap={"small"}
            className={"max-h-72 overflow-y-auto pr-1"}
          >
            {children}
          </Flex>

          {more && (
            <Typography.Text type={"secondary"} className={"text-xs"}>
              {more}
            </Typography.Text>
          )}

          {footer && <Flex justify={"end"}>{footer}</Flex>}
        </Flex>
      }
    />
  )
}
